import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { cn } from "@/lib/utils"

export interface FilterTabOption<T extends string = string> {
  value: T
  label: string
}

interface FilterTabsProps<T extends string = string> {
  options: FilterTabOption<T>[]
  value: T
  onValueChange: (value: T) => void
  className?: string
}

/**
 * Horizontal pill-style filter tabs backed by Radix TabsPrimitive.
 * Provides keyboard navigation and ARIA roles out of the box.
 * Does not render TabsContent — the caller owns what changes below.
 */
export function FilterTabs<T extends string = string>({
  options,
  value,
  onValueChange,
  className,
}: FilterTabsProps<T>) {
  return (
    <Tabs
      value={value}
      onValueChange={(v) => onValueChange(v as T)}
      className={cn("border-b border-grey4", className)}
    >
      <TabsList className="h-auto gap-1 rounded-none bg-transparent p-2">
        {options.map((opt) => (
          <TabsTrigger
            key={opt.value}
            value={opt.value}
            className="rounded-md px-2.5 py-1 text-xs font-medium text-grey5 shadow-none transition-colors hover:text-white data-[state=active]:bg-grey3 data-[state=active]:text-white data-[state=active]:shadow-none"
          >
            {opt.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
